<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-form @submit.stop.prevent="handleSubmit">
          <b-card>
            <div slot="header">
              <strong>Distribute Circulars</strong>
            </div>
            <b-row>
              <BuildingDropdown :form-group="true" :server-params="form" :on-select="getEmailTemplatesAndAccounts"/>
              <b-col sm="12">
                <form-group :validator="$v.form.emailTemplate"
                            label="Email Templates"
                            :use-horizontal="false">
                  <b-form-select v-model="form.emailTemplate" :options="emailTemplateOptions"></b-form-select>
                </form-group>
              </b-col>
              <!--applicable to accounts-->
              <b-col sm="12">
                <form-group :validator="$v.form.accounts"
                            label="Choose Accounts"
                            :use-horizontal="false">
                  <treeselect v-model="form.accounts"
                              placeholder="Select Accounts"
                              :multiple="true"
                              :options="options.account" />
                </form-group>
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button @click="$router.go(-1)" size="sm"> Back </b-button>
              <b-button type="submit"
                        size="sm"
                        variant="success"
                        class="float-right">
                Send
              </b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import BuildingDropdown from "@/components/common/BuildingDropdown";
  export default {
    data: () => ({
      form: {
        accounts: [],
        buildingId: null,
        emailTemplate: null,
      },
      emailTemplateOptions: [],
      options: {
        account: [],
      }
    }),
    validations: {
      form: {
        accounts: { required },
        emailTemplate: { required },
      },
    },
    components: {
      BuildingDropdown,
    },
    created() {
      this.getEmailTemplates();
      this.getAccounts();
    },
    methods: {
      getEmailTemplatesAndAccounts() {
        this.getEmailTemplates();
        this.getAccounts();
      },
      handleSubmit() {
        const self = this;

        self.$v.form.$touch();
        if (self.$v.form.$pending || self.$v.form.$error) return;

        let _confirmText =
          "You are about to distribute circulars. Are you sure ?",
          _okText = "Yes, Distribute",
          _action = "apis/post",
          _url = "/EmailTemplate/distribute-circular";

        self.$dialog
          .confirm(_confirmText, {
            okText: _okText,
            cancelText: "Cancel",
            loader: true,
          })
          .then((dialog) => {
            self.$store
              .dispatch(_action, {
                url: _url,
                params: self.form,
              })
              .then((response) => {
                dialog.close();
                if (response.error) {
                  self.$message.error({
                    zIndex: 10000,
                    message: response.message,
                  });
                } else {
                  self.$message.success({
                    zIndex: 10000,
                    message: response.message,
                  });

                  self.$router.go(-1);
                }
              });
          });
      },
      getEmailTemplates() {
        const self = this;
        self.$store
          .dispatch("apis/get", {
            url: "/EmailTemplate/",
            params: {
              buildingId: self.form.buildingId,
            }
          })
          .then((response) => {
            if (response.error) {
              self.$message.error({
                zIndex: 10000,
                message: response.message,
              });
            } else {
              self.emailTemplateOptions = response.data.data.map(x => ({value: x.id, text: x.name}))
            }
          });
      },
      getAccounts() {
        const self = this;
        self.$store
          .dispatch("apis/get", {
            url: "/account",
            params: {
              buildingId: self.form.buildingId,
            }
          })
          .then((response) => {
            if (response.error) {
              self.$message.error({
                zIndex: 10000,
                message: response.message,
              });
            } else {
              self.options.account = [
                {
                  id: "all",
                  label: "Select All",
                  children: response.data.data.map((x) => ({
                    id: x.accountId,
                    label: `${x.accountId}# ${x.name}`,
                  })),
                },
              ];
            }
          });
      },
    },
  };
</script>
